import { call, put, select, takeEvery } from "redux-saga/effects"

import {
    GET_ADMIN_BILLING_EVENTS,
    GET_BILLING_EVENTS_FILTER_OPTIONS
} from "./actionTypes"

import {
    getAdminBillingEventsSuccess,
    getAdminBillingEventsError,
    getBillingEventsFilterOptionsSuccess,
    getBillingEventsFilterOptionsError
} from "./actions"

import {
    genericGetRequest,
    genericGetRequest_2
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildAdminBillingEventsCacheKey } from "helpers/sf_utils"

const inFlightBillingEventsRequests = new Set()

function* onGetAdminBillingEvents(action) {
    try {
        const useCache = Boolean(action.payload?.useCache);
        const filters = action.payload?.filters || {};
        const pageNumber = action.payload?.page_number || 1;
        const queryParams = action.payload || {};
        const cacheKey = useCache ? buildAdminBillingEventsCacheKey(queryParams) : null;
        const requestKey = `${cacheKey}:${pageNumber}`;
        const cachedPage = useCache
            ? yield select((state) => state.AdminBillingEvents.page_cache?.[cacheKey]?.[pageNumber])
            : null;

        if (useCache && cachedPage) {
            return;
        }

        if (useCache && inFlightBillingEventsRequests.has(requestKey)) {
            return;
        }

        if (useCache) {
            inFlightBillingEventsRequests.add(requestKey);
        }

        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/billing_events`,
            {
                filters: JSON.stringify(filters),
                page_number: pageNumber,
                sort_column: queryParams.sort_column,
                sort_direction: queryParams.sort_direction
            },
            {
                Authorization: user.token,
            }
        );

        yield put(getAdminBillingEventsSuccess(response, {
            useCache,
            cacheKey,
            appendResults: Boolean(action.payload?.appendResults),
        }));
    } catch (error) {
        yield put(getAdminBillingEventsError(error))
    } finally {
        if (action.payload?.useCache) {
            const pageNumber = action.payload?.page_number || 1;
            const cacheKey = buildAdminBillingEventsCacheKey(action.payload || {});
            inFlightBillingEventsRequests.delete(`${cacheKey}:${pageNumber}`);
        }
    }
}

function* onGetBillingEventsFilterOptions() {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/billing_events/filter_options`,
            {},
            {
                Authorization: user.token,
            }
        )
        yield put(getBillingEventsFilterOptionsSuccess(response))
    } catch (error) {
        yield put(getBillingEventsFilterOptionsError(error))
    }
}

function* AdminBillingEventsSaga() {
    yield takeEvery(GET_ADMIN_BILLING_EVENTS, onGetAdminBillingEvents)
    yield takeEvery(GET_BILLING_EVENTS_FILTER_OPTIONS, onGetBillingEventsFilterOptions)
}

export default AdminBillingEventsSaga
